<template>
  <div class="index-box">
    <div class="lzcontainer">
      <div class="header">
        <div class="header-container">
          <a class="logo" href="/">
            <img src="./assets/logo.png" alt="AI南康">
          </a>
          <div class="header-menu">
            <div class="header-menu-item">
              <a style="color: #2086e0" class="link" href="/">首页</a>
            </div>
            <div class="header-menu-item">
              <a class="link" href="/dist/" target="_blank">产品实现</a>
            </div>
            <div class="header-menu-item">
              <a class="link" href="/dist/#/app" target="_blank">APP工作台</a>
            </div>
            <div class="header-menu-item">
              <a class="link" href="/dist/#/data" target="_blank">数据</a>
            </div>
            <div class="header-menu-item">
              <a class="link" href="/dist/#/operate" target="_blank">运营</a>
            </div>
            <div class="header-menu-item">
              <a class="link" href="/dist/#/buy" target="_blank">采购</a>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <el-carousel :interval="5000" height="600px">
          <el-carousel-item v-for="(item, index) in items" :key="index">
            <img class="swiper-img" :src="item.imageUrl" alt="">
          </el-carousel-item>
        </el-carousel>
        <div class="recommend">
          <div class="row">
            <a class="box" href="#">
              <div>
                <div style="transform: translate(0px, 0px); opacity: 1;">
                  <h2 class="uiElps title_2TysZde03d">多品类家具智能方案</h2>
                  <h3 class="subtitle_2GSXKde03d">丰富的成熟方案，一分钟智能提升</h3>
                </div>
              </div>
            </a>

            <a class="box" href="#">
              <div>
                <div style="transform: translate(0px, 0px); opacity: 1;">
                  <h2 class="uiElps title_2TysZde03d">三维工艺适配</h2>
                  <h3 class="subtitle_2GSXKde03d">针对家具的工艺设计，三维适配各类家具</h3>
                </div>
              </div>
            </a>
            <a class="box" href="#">
              <div>
                <div style="transform: translate(0px, 0px); opacity: 1;">
                  <h2 class="uiElps title_2TysZde03d">多形态安装</h2>
                  <h3 class="subtitle_2GSXKde03d">完整的解决方案-嵌入式与分布式，定制成本最低</h3>
                </div>
              </div>
            </a>
            <a class="box" href="#">
              <div>
                <div style="transform: translate(0px, 0px); opacity: 1;">
                  <h2 class="uiElps title_2TysZde03d">自主AMCU</h2>
                  <h3 class="subtitle_2GSXKde03d">自主AMCU核心板，低功耗，高安全性</h3>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="product">
          <div class="title">
            <h2>全品类家具智能化解决方案<br>助力一分钟智能</h2>
            <h3>适用于家具企业、设计中心。厂商专注制造好产品, 完成智能升级</h3>
          </div>
          <div class="list">
            <div class="row">
              <div class="product-flag box col-md-4" @click="handleClick('one')">
                <img src="http://travel-red.oss-cn-hangzhou.aliyuncs.com/bece0ba4063bd0353f8c564365ae9a03.png"
                  alt="母婴智能家具解决方案">
                <div class="product-name">母婴智能家具</div>
              </div>
              <div class="product-flag box col-md-4" @click="handleClick('two')">
                <img src="http://travel-red.oss-cn-hangzhou.aliyuncs.com/a0808d9195391a246374c2997ad8eab4.png"
                  alt="AI+宠物智能家具解决方案">
                <div class="product-name">宠物智能柜</div>
              </div>
              <div class="product-flag box col-md-4" @click="handleClick('three')">
                <img src="./assets/bed.jpg" alt="商务智能家具解决方案">
                <div class="product-name">毫米波雷达床</div>
              </div>
            </div>
          </div>
          <div class="gallery">
            <div v-if="currentType === 'one'" class="lzjumbotron" style="display: block;">
              <img class="left" src="http://travel-red.oss-cn-hangzhou.aliyuncs.com/3ee5438ac43cb1180caa9b5c389e9c88.png">
              <div class="right">
                <h4>母婴智能家具解决方案</h4>
                <p>适用于婴儿床、婴儿车、儿童床、儿童家具类</p>
                <span class="linkBtn" @click="handleToDetail('2')">查看详情</span>
              </div>
              <div class="clearfix"></div>
            </div>
            <div v-if="currentType === 'two'" class="lzjumbotron">
              <img class="left" src="http://travel-red.oss-cn-hangzhou.aliyuncs.com/d948d9ea4bfd12fe1b8f47dd5068ecb5.jpg">
              <div class="right">
                <h4>AI+宠物智能家具解决方案</h4>
                <p>适用于猫舍、狗舍、兔舍等</p>
                <span class="linkBtn" @click="handleToDetail('3')">查看详情</span>
              </div>
              <div class="clearfix"></div>
            </div>
            <div v-if="currentType === 'three'" class="lzjumbotron">
              <img class="left" src="./assets/bed.jpg">
              <div class="right">
                <h4>商务智能家具解决方案</h4>
                <p>适用于实木床、软体床等</p>
                <span class="linkBtn" @click="handleToDetail('1')">查看详情</span>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
        <div class="container platform">
          <div class="title">
            <h2>一站式家具智能化平台</h2>
            <h3>打通产品-销售-终端用户运营的全链路服务</h3>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="platform-item">
                <div class="platform-head">
                  <span class="icon"><img
                      src="http://travel-red.oss-cn-hangzhou.aliyuncs.com/62a9b41bb6012ec5825f9e7f11a94c22.png"></span>
                  <h4>联网模组</h4>
                  <small>设备智能化第一步, 支持主流通信协议, 权威认证通行全球, 低功耗, 即插即用</small>
                  <!--              <div class="link-to-detail"><a href="#">立即进入 →</a></div>-->
                </div>
                <div class="platform-body">
                  <ul>
                    <li>Wi-Fi</li>
                    <li>Bluetooth</li>
                    <li>Zigbee</li>
                    <li>NB-IoT</li>
                    <li>5G</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="platform-item">
                <div class="platform-head">
                  <span class="icon"><img
                      src="http://travel-red.oss-cn-hangzhou.aliyuncs.com/e27cc81c48e8cec0f67de3d0a6916b5f.png"></span>
                  <h4>AI云</h4>
                  <small>全球部署的集群数据中心, 赋予智能产品毫秒级服务响应能力, 构建物联网行业远景</small>
                  <!--              <div class="link-to-detail"><a href="#">立即进入 →</a></div>-->
                </div>
                <div class="platform-body">
                  <ul>
                    <li>设备连接与管理</li>
                    <li>海量数据分析</li>
                    <li>边缘计算能力</li>
                    <li>智能云服务</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="platform-item">
                <div class="platform-head">
                  <span class="icon"><img
                      src="http://travel-red.oss-cn-hangzhou.aliyuncs.com/1ef76e23ae971e74dedd2a71e6e60e33.png"></span>
                  <h4>控制端</h4>
                  <small>智能产品控制中枢, 支持远程多路径操作和第三方语音控制, 智能场景轻松实现</small>
                  <!--              <div class="link-to-detail"><a href="#">立即进入 →</a></div>-->
                </div>
                <div class="platform-body">
                  <ul>
                    <li>App控制端</li>
                    <li>小程序控制端</li>
                    <li>Web控制端</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="platform-item">
                <div class="platform-head">
                  <span class="icon"><img
                      src="http://travel-red.oss-cn-hangzhou.aliyuncs.com/f8f40944d1ec6a459a9e17b88a9878a1.png"></span>
                  <h4>SaaS中心</h4>
                  <small>设备端全链路SaaS服务, 整合数据中心、运营平台与营销赋能服务, 智能化不止于产品</small>
                  <!--              <div class="link-to-detail"><a href="#">立即进入 →</a></div>-->
                </div>
                <div class="platform-body">
                  <ul>
                    <li>数据中心</li>
                    <li>运营中心</li>
                    <li>营销中心</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flow">
          <div>
            <div style="transform: translate(0px, 0px); opacity: 1;">
              <div class="line"></div>
              <div class="list">
                <span class="item">
                  <br>一分钟生成智能化方案
                </span>
                <span class="item">
                  <br>设计打样
                </span>
                <span class="item">
                  <br>成品接入云平台
                </span>
                <span class="item">
                  <br>批量生产
                </span>
                <span class="item">
                  <br>销往全球
                </span>
                <span class="item">
                  <br>终端用户管理
                </span>
              </div>
            </div>
          </div>
          <div>
            <div style="transform: translate(0px, 0px); opacity: 1;">
              <a class="linkBtn" href="/dist/" target="_blank">立即创建智能家具</a>
            </div>
          </div>
        </div>
        <div class="container earth">
          <div class="title">
            <h2>客户案例</h2>
            <h3>助力企业腾飞</h3>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="earth-swiper-container swiper-container-initialized swiper-container-horizontal">
                <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px);">
                  <div class="swiper-slide swiper-slide-active" style="width: 940px;">
                    <div class="earth-img">
                      <img src="http://travel-red.oss-cn-hangzhou.aliyuncs.com/033fbe7e9378f8c84ba35bac39ba76fd.jpg">
                    </div>
                  </div>
                </div>
                <div class="earth-swiper-button-next swiper-button-disabled" tabindex="0" role="button"
                  aria-label="Next slide" aria-disabled="true"></div>
                <div class="earth-swiper-button-prev swiper-button-disabled" tabindex="0" role="button"
                  aria-label="Previous slide" aria-disabled="true"></div>
                <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
              </div>
            </div>
          </div>
          <hr>
        </div>
        <div class="container">
          <div class="part">
            <div class="row">
              <div class="col-md-6">
                <div class="left">
                  <div class="row">
                    <div class="col-md-6">
                      <img src="./assets/case1.jpg">
                    </div>
                    <div class="col-md-6">
                      <img src="./assets/case2.jpg">
                    </div>
                    <div class="col-md-6">
                      <img src="./assets/case3.jpg">
                    </div>
                    <div class="col-md-6">
                      <img src="./assets/case4.png">
                    </div>
                    <div class="col-md-6">
                      <img src="./assets/case5.png">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="right">
                  <small>合作伙伴</small>
                  <h2>携手客户<br>与伙伴共筑智能未来</h2>
                  <!--              <button class="linkBtn">查看更多</button>-->
                </div>
              </div>
            </div>
          </div>
          <hr>
        </div>

        <div class="container safe">
          <div class="title">
            <h2>安全与合规</h2>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="safe-img">
                <img src="./assets/image1.png"><br><br>
                ISO 27001 是信息安全管理体系(ISMS) 国际标准, 为各类组织建立并运行信息安全管理体系提供了最佳实践指导。
              </div>
            </div>
            <div class="col-md-4">
              <div class="safe-img">
                <img src="./assets/image2.png"><br><br>
                ISO 9001 是一个系统性保证公司产品质量及运作的指导性纲领和规范架构, 确保满足客户及相关法律规要求。
              </div>
            </div>
            <div class="col-md-4">
              <div class="safe-img">
                <img src="./assets/image3.png"><br><br>
                ISO 27017 为云计算的信息安全方面提供了指导, 推荐实施专门针对云的信息安全控制。此实施规程针对云服务提供商提供了更多信息安全控制实施指导。
              </div>
            </div>
          </div>
        </div>
        <div class="container safe">
          <div class="title">
            <h2>关于我们</h2>
          </div>
          <div class="row">
            <div class="col-md-12">
              根据江西省委省政府和赣州市委市政府的指示精神，为推动南康家具产业实现创新发展、产业转型升级，打造南康模式，建成“家具大规模个性化定制”的国家级智能制造示范及“一带一路”个性化智能家具“买全球、卖全球”的国际示范，南康区人民政府与宁波市智能制造产业研究院于2019年4月联合共建“中国家具智能制造创新中心”，注册登记为赣州市南康区家具智能制造创新中心研究院（以下简称：南康创新中心研究院）。南康创新中心研究院自成立以来，一直专注于整合家具行业研究资源、家具智能制造、智慧能源、智能家具、技术咨询与技术服务等；以智能技术研究为手段，以产业落地为目的的运营管理模式，致力于“家具大规模个性化定制”的国家级智能制造示范及“一带一路”个性化智能家居“买全球、卖全球”的国际示范的建设，以及工业AI云脑、5G工业互联网、云MOM和云MES系统、家具智能制造、智能家居等技术的研究和推广。
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="footer-box">
          <div class="footer-cont">
            <a href="/"><img src="./assets/logo.png" alt="ai南康"></a>
            <div class="footer-t flexbox">
              <a href="/" target="_self">首页</a>
              <a href="/dist/" target="_blank">产品实现</a>
              <a href="/dist/#/app" target="_blank">APP工作台</a>
              <a href="/dist/#/data" target="_blank">数据</a>
              <a href="/dist/#/operate" target="_blank">运营</a>
              <a href="/dist/#/buy" target="_blank">采购</a>
            </div>
            <p>
              全国咨询电话：19970936363&nbsp;&nbsp;&nbsp;
              技术支持邮箱：wenzhuo@guanyingis.com&nbsp;&nbsp;&nbsp;
              Copyright©2019 赣州市南康区家具智能制造创新中心研究院 版权所有<br>
              地址：南康区镜坝镇园全村家居小镇木屋区08 <a href="http://www.miitbeian.gov.cn/" rel="nofollow"
                target="_blank">赣ICP备19008747号</a>
              <a href="//www.ainankang.com/zhishi/4855.html"></a>
            </p>
            <li style="list-style:none"><a href="http://shuzhiren.com/post/13019.html"></a></li>
            <li style="list-style:none"><a href="http://shuzhiren.com/post/4190.html"></a></li>
            <li style="list-style:none"><a href="http://shuzhiren.com/post/26021.html"></a></li>
            <li style="list-style:none"><a href="http://shuzhiren.com/post/14405.html"></a></li>
            <li style="list-style:none"><a href="http://shuzhiren.com/post/35899.html"></a></li>
            <div class="qrcode"><img src="./assets/qrcode.jpg" alt="二维码"></div>
          </div>
        </div>
      </div><!-- end footer -->
    </div>
  </div>
</template>

<script>

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Index',
  components: {
  },
  data () {
    return {
      items: [
        { imageUrl: 'http://travel-red.oss-cn-hangzhou.aliyuncs.com/e8c397ed8f17ca726929913045d0ba03.jpg' },
        { imageUrl: 'http://travel-red.oss-cn-hangzhou.aliyuncs.com/e8c397ed8f17ca726929913045d0ba03.jpg' },
        { imageUrl: 'http://travel-red.oss-cn-hangzhou.aliyuncs.com/e8c397ed8f17ca726929913045d0ba03.jpg' },
      ],
      currentType: 'one'
    };
  },
  methods: {
    handleClick (type) {
      this.currentType = type;
    },
    handleToDetail (type) {
      this.$router.push({
        path: '/detail', query: {
          type
        }
      });
      window.scrollTo(0, 0); // 将页面滚动到顶部
      console.log(type, '111111111111');
    }

  }
}
</script>

<style>
body {
  font-family: PingFang SC, PingFang-SC-Regular, Helvetica Neue, Helvetica, Arial, Microsoft Yahei, Hiragino Sans GB, Heiti SC, WenQuanYi Micro Hei, sans-serif;
  margin: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  background-color: #fff;
  font-feature-settings: "tnum";
  display: block;
}

body,
html {
  width: 100%;
}

*,
:after,
:before {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.lzcontainer {
  min-width: 1200px;
  overflow: hidden;
}

.header {
  height: 65px;
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
  position: relative;
  z-index: 20;
  display: flex;
  justify-content: center;
}

.header .header-container {
  width: 1200px;
  display: flex;
}

.header .logo {
  width: 112px;
  display: block;
  height: 24px;
  line-height: 64px;
}

.header .logo img {
  height: 24px;
  vertical-align: middle;
  border-style: none;
}

.header .header-menu {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0%;
  margin: 0 0 0 10px;
}

.header .header-menu .header-menu-item {
  position: relative;
  display: inline-block;
  padding: 0 15px;
}

.header .header-menu .header-menu-item .link {
  display: inline-block;
  height: 70px;
  line-height: 70px;
  font-size: 18px;
  font-weight: 400;
  color: #222;
  border-bottom: 3px solid transparent;
  cursor: pointer;
}

.header .header-menu .header-menu-item a:hover {
  text-decoration: yellowgreen;
}

.header .header-right {
  text-align: right;
  width: 240px;
  height: 70px;
  line-height: 70px;
}

.header .header-right .linkBtn {
  height: 38px;
  line-height: 34px;
  font-size: 18px;
  display: inline-block;
}

.header .header-right .link {
  background: transparent;
  color: #4385f4;
  border-color: transparent;
  font-size: 18px;
  font-weight: 500;
}

.header .header-right .split {
  line-height: 64px;
  display: inline-block;
  width: 1px;
  height: 23px;
  background-color: #e5e5e5;
  margin: 0 20px;
  vertical-align: middle;
}

.header .header-right .primary {
  color: #fff;
  border-color: #1973e8;
  background: #1973e8;
  padding: 0 31px;
  text-align: right;
  border-radius: 2px;
}

.header a {
  background-color: transparent;
  outline: none;
  cursor: pointer;
}

.header a,
.header a:focus,
.header a:hover {
  text-decoration: none;
  color: inherit;
}

.content .swiper-container {
  height: 600px;
  /* width: 1920px; */
  overflow: hidden;
  position: relative;
}

.swiper-img {
  width: 100%;
}

.content .swiper-container .swiper-wrapper {
  width: 100%;
}

.content .swiper-container .swiper-slide {
  height: 100%;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: auto 100%;
  flex-shrink: 0;
  z-index: 1;
}

.content .swiper-container .swiper-slide a {
  display: block;
  width: 100%;
  height: 100%;
}

.content .swiper-container .swiper-pagination {
  margin-bottom: 30px;
}

.content .swiper-container .swiper-pagination span {
  width: 30px;
  height: 3px;
  border-radius: 0;
}

.content .swiper-container .swiper-pagination .swiper-pagination-bullet-active {
  background: #fff;
}

.content .recommend {
  height: 161px;
  padding: 40px 0;
  border-bottom: 1px solid #e5e5e5;
  text-align: left;
}

.content .recommend .row {
  display: flex;
  justify-content: center;
}

.content .recommend .row .box {
  display: block;
  width: 220px;
  margin: 0 70px 0 0;
}

.content .recommend .row .box h2 {
  height: 24px;
  font-size: 18px;
  font-weight: 600;
  color: #222;
  line-height: 24px;
  letter-spacing: 1px;
  transition: all 0.3s;
  margin: 0 0 15px;
}

.content .recommend .row .box h3 {
  height: 40px;
  font-size: 14px;
  font-weight: 400;
  color: #999;
  line-height: 20px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.content .recommend .row a {
  text-decoration: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  -webkit-text-decoration-skip: objects;
}

.content .recommend .row h2:hover {
  color: #1890ff;
}

.content .platform {
  padding: 110px 0 0;
}

.content .platform .title {
  padding: 0 0 70px;
}

.content .platform h2,
.content .platform h3 {
  font-weight: 500;
  text-align: center;
}

.content .platform h2 {
  margin: 0 auto;
  width: 500px;
  font-size: 40px;
  color: #222;
  line-height: 56px;
}

.content .platform h3 {
  margin: 20px auto 0;
  width: 700px;
  font-size: 16px;
  color: #999;
  line-height: 26px;
  text-overflow: ellipsis;
}

.content .platform .platform-item {
  border: 1px solid #e0e0e0;
  background: #fff;
  min-height: 512px;
  transition: transform 0.2s linear;
}

.content .platform .platform-item .icon {
  color: #1973e8;
  font-size: 32px;
}

.content .platform .platform-item .platform-head {
  background: #fafafa;
  height: 240px;
  padding: 25px 30px 30px;
}

.content .platform .platform-item .platform-head a {
  margin-top: 15px;
  line-height: 16px;
  color: #4385f4;
  display: block;
}

.content .platform .platform-item .platform-head small {
  height: 72px;
  font-size: 14px;
  font-weight: 400;
  color: #999;
  line-height: 24px;
  overflow: hidden;
  margin: 0 0 15px;
}

.content .platform .platform-item .platform-body {
  padding: 25px 30px 20px;
}

.content .platform .platform-item .platform-body ul {
  text-decoration: none;
  list-style-type: none;
}

.content .platform .platform-item .platform-body ul li {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #666;
  line-height: 20px;
  margin-bottom: 25px;
}

.content .platform .platform-item:hover {
  transform: translateY(-5px);
  border: #1973e8 solid 1px;
  box-shadow: 10px 10px 5px #e0e0e0;
  cursor: pointer;
}

.content .product {
  padding: 110px 0 0;
}

.content .row {
  display: flex;
}

.content .product .title {
  padding: 0 0 70px;
}

.content .product h2,
.content .product h3 {
  font-weight: 500;
  text-align: center;
}

.content .product h2 {
  margin: 0 auto;
  width: 500px;
  font-size: 40px;
  color: #222;
  line-height: 56px;
}

.content .product h3 {
  margin: 20px auto 0;
  width: 700px;
  font-size: 16px;
  color: #999;
  line-height: 26px;
  text-overflow: ellipsis;
}

.content .product .list {
  width: 1080px;
  margin: 0 auto;
  position: relative;
  text-align: center;
}

.content .product .list .box img {
  width: 100%;
  height: 200px;
}

.content .product .list .box .product-name {
  text-align: center;
  margin: 20px 0 0;
  height: 20px;
  font-size: 16px;
  font-weight: 400;
  color: #999;
  line-height: 20px;
  transition: color 0.3s;
}

.content .product .gallery {
  width: 1150px;
  border: 1px solid #e5e5e5;
  margin: 50px auto 0;
}

.content .product .gallery .lzjumbotron {
  height: 530px;
}

.content .product .gallery .lzjumbotron img {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 600px;
  height: 100%;
  background: #f3f5f4;
  overflow: hidden;
  float: left;
  text-align: center;
}

.content .product .gallery .lzjumbotron .right {
  padding: 128px 0 0 80px;
  width: 520px;
  overflow: hidden;
}

.content .product .gallery .lzjumbotron .right h4 {
  height: 22px;
  font-size: 16px;
  font-weight: 400;
  color: #999;
  line-height: 22px;
  -webkit-line-clamp: 1;
}

.content .product .gallery .lzjumbotron .right p {
  font-size: 32px;
  max-height: 92px;
  line-height: 46px;
  font-weight: 500;
  color: #222;
  letter-spacing: 2px;
  margin: 10px 0 60px;
  -webkit-line-clamp: 2;
}

.content .product .gallery .lzjumbotron .right .btn {
  color: #97bbe1;
  border-radius: 2px;
  padding: 0 30px;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  line-height: 36px;
  border: 1px solid #97bbe1;
}

.content .product .gallery .lzjumbotron .right .btn:hover {
  color: #fff;
}

.content .earth {
  margin-top: 60px;
  text-align: center;
}

.content .earth .title {
  padding: 0 0 70px;
}

.content .earth h2,
.content .earth h3 {
  font-weight: 500;
  text-align: center;
}

.content .earth h2 {
  margin: 0 auto;
  width: 500px;
  font-size: 40px;
  color: #222;
  line-height: 56px;
}

.content .earth h3 {
  margin: 20px auto 0;
  width: 700px;
  font-size: 16px;
  color: #999;
  line-height: 26px;
  text-overflow: ellipsis;
}

.content .earth .earth-img img {
  width: 100%;
  height: 540px;
  object-fit: cover;
}

.content .safe {
  margin-top: 60px;
  text-align: center;
}

.content .safe .title {
  padding: 0 0 70px;
}

.content .safe h2,
.content .safe h3 {
  font-weight: 500;
  text-align: center;
}

.content .safe h2 {
  margin: 0 auto;
  width: 500px;
  font-size: 40px;
  color: #222;
  line-height: 56px;
}

.content .safe h3 {
  margin: 20px auto 0;
  width: 700px;
  font-size: 16px;
  color: #999;
  line-height: 26px;
  text-overflow: ellipsis;
}

.content .safe .safe-img img {
  /* width: 30%; */
}

.content .part {
  margin-top: 60px;
}

.content .part .left img {
  margin-top: 20px;
  height: 110px;
  width: 100%;
}

.content .part .right {
  padding: 60px;
}

.content .part .right small {
  font-size: 16px;
  color: #999;
  line-height: 26px;
}

.content .part .right h2 {
  font-size: 40px;
  color: #222;
  line-height: 56px;
}

.content .linkBtn {
  height: 42px;
  line-height: 38px;
  padding: 0 40px;
  border-color: hsla(0, 0%, 100%, 0.5);
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  color: #97bbe1;
  border: 1.32px solid #97bbe1;
  background: transparent;
  border-radius: 2px;
  transition: all 0.3s;
  cursor: pointer;
  text-decoration: none;
}

.content .linkBtn:hover {
  background: #1890ff;
  border: 1px solid #1890ff;
  color: #fff;
}

.content .flow {
  margin-top: 120px;
  height: 334px;
  background: #121212;
  text-align: center;
  padding: 70px 0;
}

.content .flow .line {
  background: url("./assets/line.png") no-repeat;
  background-size: 100% 71px;
  width: 1002px;
  height: 71px;
  margin-left: auto;
  margin-right: auto;
}

.content .flow .item {
  position: relative;
  margin: 0 7px;
  z-index: 2;
  display: inline-block;
  width: 167px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  text-align: center;
  cursor: pointer;
}

.content .flow .item .icon {
  font-size: 32px;
}

.content .flow .linkBtn {
  margin: 60px 0 0;
  height: 42px;
  line-height: 38px;
  padding: 0 40px;
  border-color: hsla(0, 0%, 100%, 0.5);
  color: #fff;
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  border: 1.32px solid #97bbe1;
  background: transparent;
  border-radius: 2px;
  transition: all 0.3s;
  cursor: pointer;
  text-decoration: none;
}

.content .flow .linkBtn:hover {
  background: #1890ff;
  border: 1px solid #1890ff;
}

.content .zoology {
  padding: 110px 0 0;
}

.content .zoology .title {
  padding: 0 0 70px;
}

.content .zoology h2,
.content .zoology h3 {
  font-weight: 500;
  text-align: center;
}

.content .zoology h2 {
  margin: 0 auto;
  width: 500px;
  font-size: 40px;
  color: #222;
  line-height: 56px;
}

.content .zoology h3 {
  margin: 20px auto 0;
  width: 700px;
  font-size: 16px;
  color: #999;
  line-height: 26px;
  text-overflow: ellipsis;
}

.content .zoology .zoology-img {
  padding: 20px;
}

.content .zoology .zoology-img img {
  width: 100%;
  border: 1px #e0e0e0 solid;
}

.content .zoology .zoology-text {
  padding: 60px;
}

.content .zoology .zoology-text .maintitle {
  height: 38px;
  font-size: 26px;
  font-weight: 500;
  color: #292929;
  line-height: 38px;
}

.content .zoology .zoology-text .subtitle {
  max-height: 66px;
  min-height: 44px;
  font-size: 16px;
  font-weight: 400;
  color: #999;
  line-height: 22px;
  margin: 10px 0 40px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.footer-cont p a {
  text-decoration: none;
  color: #6e6e6e;
}

.footer {
  margin-top: 100px;
  display: block;
  position: relative;
  width: 100%;
  background-color: #222222;
}

.footer-cont {
  position: relative;
  width: 1100px;
  padding: 40px 0 100px 0;
  margin: 0 auto;
}

.footer-t {
  width: 722px;
  margin-top: 45px;
  padding-bottom: 20px;
  font-size: 16px;
  color: #e1e1e1;
  border-bottom: 1px solid #373737;
}

.footer-t a {
  margin-right: 35px;
  text-decoration: none;
  color: #e1e1e1;
}

.footer-t a:hover {
  text-decoration: none;
  color: #e1e1e1;
}

.footer-cont p {
  font-size: 14px;
  color: #6e6e6e;
  margin-top: 22px;
  line-height: 2;
}

.footer-cont .qrcode {
  position: absolute;
  right: 10px;
  top: 115px;
}

.qrcode img {
  width: 100px;
  height: 100px;
}

.container .row {
  width: 67%;
  display: flex;
  justify-content: center;
  margin-left: 50%;
  transform: translateX(-50%);

  .col-md-3 {
    margin-left: 50px;
  }
}

.part .row .col-md-6 {
  margin-left: 20px;
}

.part .row .col-md-6 .row {
  width: 80%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: start;

}



@media screen and (max-width:1366px) {
  .content .swiper-container {
    height: 426px !important;
  }
}
</style>
